module.exports = __webpack_public_path__ + "img/public/SiteIcons/twitterShareIcon.svg?f0ae9813";